import dayjs from "dayjs";
import { ZOption } from "src/types/ZOption";

import { ZDemoData } from "./demoDataTypes";

export const countryRef: Record<string, string> = {
  be: "Belarus",
  bn: "Brunei",
  eg: "Egypt",
  es: "Spain",
  fr: "France",
  gr: "Greece",
  hu: "Hungary",
  id: "Indonesia",
  it: "Italy",
  kh: "Cambodia",
  lk: "Sri Lanka",
  mm: "Myanmar",
  my: "Malaysia",
  mx: "Mexico",
  nl: "Netherlands",
  pt: "Portugal",
  ru: "Russia",
  sg: "Singapore",
  th: "Thailand",
  tz: "Tanzania",
  vn: "Vietnam",
};
export const countryOptions = Object.entries(countryRef).map(
  ([value, label]) => ({
    value,
    label,
  }),
);
countryOptions.sort((a, b) => a.label.localeCompare(b.label));

export const generateDemoData = (count: number): ZDemoData[] => {
  const data: ZDemoData[] = [];
  for (let i = 0; i < count; i++)
    data.push({
      id: i + 1,
      name: cap(genWord(2, 6, 0.5)),
      count: Math.floor(Math.random() * 1000),
      country: makeCountryOption(genCountryCode()),
      beginDate: genDate(),
    });
  return data;
};

// export const loadDemoData = async (): Promise<DemoData[]> => {
//   await delay(1000);
//   if (myData.length === 0) {
//     myData = generateDemoData(50);
//   }
//   return myData;
// };

const volwes = "aoiue";
const consonants = "bcdfghjklmnprstvwxyz";
const genLetter = (letters: string) =>
  letters[Math.floor(Math.random() * letters.length)]!;
const genWord = (min: number, max: number, pEnd: number) => {
  const n = Math.floor((max - min) * Math.random()) + min;
  const end = Math.random() < pEnd;
  let res = "";
  for (let i = 0; i < n; i++) {
    res += genLetter(consonants);
    res += genLetter(volwes);
  }
  if (end) res += genLetter(consonants);
  return res;
};
const countryCodes = Object.keys(countryRef);
const genCountryCode = (): string =>
  countryCodes[Math.floor(Math.random() * countryCodes.length)]!;

const makeCountryOption = (countryCode: string): ZOption => ({
  value: countryCode,
  label: countryRef[countryCode] ?? countryCode,
});

const genDate = (): string => {
  const now = dayjs();
  const start = now.subtract(2, "years");
  const finish = now.add(1, "year");
  const t0: number = start.valueOf();
  const t1: number = finish.valueOf();
  const rnd = dayjs(t0 + Math.random() * (t1 - t0));
  return rnd.format();
};

const cap = (name: string): string =>
  name.slice(0, 1).toUpperCase() + name.slice(1);
